module.exports = __webpack_public_path__ + "img/2.7bbcf215.jpg";